'use client'

// Narrow, per-concern selector hook for opening the slide-out shopping-cart panel
// from the header cart nav item (#118 server-chrome, Step 3). Exposes ONLY the
// single action that flips showShoppingCartSidePanel on. The panel-visibility flag
// moved off Overmind to the Zustand ui store (Phase C2 part 1); openCart mirrors
// the former actions.cartNavItemClicked. The panel itself (ShoppingCartPanel) is a
// separate island (Step 2).

import { useUiStore } from '../../store/uiStore'

export function useCartPanel() {
  const openCart = useUiStore((s) => s.openCart)
  return { openCart }
}
